import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import '../../css/BisharatMain.css';
import AuthService from "../../services/AuthService";
import { MemberLinkBtn } from "../../styles/Elements";
import { isEmail } from "validator";
import translate from "../../languages/translate";


const required = value => {
  if (!value) {
    return (
      <div className="alertDanger" role="alert">
        <p className="alertDanger">  {translate("mandatory")}
          </p> 
      </div>
    );
  }
};

const email = value => {
    if (!isEmail(value)) {
      return (
        <div className="alertDanger" role="alert">
          <p className="alertDanger">
       {translate("email-not-validated")}
         </p>
        </div>
      );
    }
  };



export default class ResetUserOrPass extends Component {
  constructor(props) {
    super(props);
    this.handleResetUserOrPass = this.handleResetUserOrPass.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);

    this.state = {
      email : "",  
      successful: false,
      message: ""
    };
  }



  onChangeEmail(e) {
    this.setState({
        email: e.target.value
    });
  }



  handleResetUserOrPass(e) {
    e.preventDefault();

    this.setState({
      message: "",
      successful: false
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      AuthService.resetUserOrPasswordViaEmail(
        this.state.email
      ).then(
        response => {

          this.setState({
            message: response.data.message,
            successful: true
          }); 
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.setState({
            successful: false,
            message: resMessage
          });
        }
      );
     
    }
  }

  render() {
   
    return (

      <div className='mainCreate'>

  <div className="top-container-forms modcreate-topform">
  <div className="create-form modcreate-form"> 
        <div className="register-not-signed">
          <Form
            onSubmit={this.handleResetUserOrPass}
            ref={c => {
              this.form = c;
            }}
          >
            {!this.state.successful && (
              <div>
                <div className="form-group">
                <label htmlFor="email">{translate("email")} </label>
                  <Input
                    type="text"
                    className="form-control-mod"
                    name="email"
                    value={this.state.email}
                    onChange={this.onChangeEmail}
                    validations={[required, email]}
                  />
                </div>

              

                <div className="form-group">
                  <button className="btn btn-primary btn-block"> {translate("restore-user-pass")} </button>
                </div>
                
              </div>
            )}

            {this.state.message && (
              <div className="form-group">
                <div
                  className={
                    this.state.successful
                      ? "alertSuccess" 
                      : "alertDanger"
                  }
                  role="alert"
                >
                  
                  {this.state.message === 'Error: Email not found!' && translate("email-not-validated")} 
                  {this.state.message === 'Email Sent Successfully.' && translate("mail-sent-success")}
                  {this.state.message === 'Error: Token Invalid!' && translate("link-unavailable")}
                

                </div>
             
              </div>
            )}
            <CheckButton
              style={{ display: "none" }}
              ref={c => {
                this.checkBtn = c;
              }}
            />
          </Form>
          <MemberLinkBtn to={'/profile'}> {translate("back")} </MemberLinkBtn>
      </div>
      </div>
</div>
  

        </div>
    );
  }
} 